var secondary = localStorage.getItem('secondary_color') || '#FFA47A';
export default{
    data() {
        return {
            line: {
                options: {
                    chart: {
                        type: "bar",
                        height: 270,
                        toolbar: {
                            show: false,
                        },
                    },
                    plotOptions: {
                        bar: {
                            horizontal: false,
                            borderRadius: 6,
                            columnWidth: "16px",
                        },
                    },
                    dataLabels: {
                        enabled: false,
                    },
                    stroke: {
                        show: true,
                        width: 2,
                        colors: ["transparent"],
                    },
                    responsive: [
                        {
                            breakpoint: 1365,
                            options: {
                                chart: {
                                    height: 230,
                                },
                            },
                        }
                    ],
                    grid: {
                        show: false,
                        xaxis: {
                            lines: {
                                show: true,
                            },
                        },
                        yaxis: {
                            lines: {
                                show: false,
                            },
                        },
                    },
                    yaxis: {
                        show: false,
                        labels: {
                            show: false,
                        },
                        axisTicks: {
                            show: false,
                        },
                    },
                    xaxis: {
                        show: false,
                        labels: {
                            show: false,
                        },
                        axisTicks: {
                            show: false,
                        },
                    },
                    states: {
                        hover: {
                            filter: {
                                type: "darken",
                                value: 1,
                            },
                        },
                    },
                    tooltip: {
                        marker: {
                            show: false,
                        },
                        fixed: {
                            enabled: false,
                            position: "bottomRight",
                            offsetX: 0,
                            offsetY: 0,
                        },
                    },
                    fill: {
                        opacity: 1,
                    },
                    legend: {
                        show: false,
                    },
                    colors: ["#B7B1D7", "#B7B1D7", "#FFFFFF"],
                },
                series: [{
                    name: "Net Profit",
                    data: [30, 70, 40, 50, 70, 50, 90],
                },
                {
                    name: "Revenue",
                    data: [60, 40, 30, 60, 80, 70, 75],
                },
                {
                    name: "Free Cash Flow",
                    data: [40, 60, 35, 90, 60, 60, 60],
                },
                ],
            },
            stock: {
                options: {

                    chart: {
                        type: "bar",
                        height: 155,
                        stacked: true,
                        stackType: "100%",
                        toolbar: {
                            show: false,
                        },
                    },

                    plotOptions: {
                        bar: {
                            horizontal: false,
                            s̶t̶a̶r̶t̶i̶n̶g̶S̶h̶a̶p̶e̶: "rounded",
                            e̶n̶d̶i̶n̶g̶S̶h̶a̶p̶e̶: "rounded",
                            borderRadius: 6,
                            columnWidth: "50px",
                            barHeight: "70%",
                        },
                    },
                    grid: {
                        show: false,
                        xaxis: {
                            lines: {
                                show: false,
                            },
                        },
                    },
                    dataLabels: {
                        enabled: false,
                    },
                    fill: {
                        opacity: 1,
                    },
                    legend: {
                        show: false,
                    },
                    tooltip: {
                        marker: {
                            show: false,
                        },
                        fixed: {
                            enabled: false,
                            position: "bottomRight",
                            offsetX: 0,
                            offsetY: 0,
                        },
                    },
                    states: {
                        hover: {
                            filter: {
                                type: "darken",
                                value: 1,
                            },
                        },
                    },
                    colors: [ "#EADAD3",secondary],
                    xaxis: {
                        show: false,
                        axisBorder: {
                            show: false,
                        },
                        axisTicks: {
                            show: false,
                        },
                    },
                    yaxis: {
                        show: false,
                        axisBorder: {
                            show: false,
                        },
                        axisTicks: {
                            show: false,
                        },
                    },
                    responsive: [{
                        breakpoint: 991,
                        options: {
                            chart: {
                                height: 140,
                            },
                        },
                    },
                    {
                        breakpoint: 768,
                        options: {
                            chart: {
                                height: 120,
                            },
                        },
                    },
                    {
                        breakpoint: 576,
                        options: {
                            chart: {
                                height: 150,
                            },
                        },
                    },
                    {
                        breakpoint: 480,
                        options: {
                            chart: {
                                height: 120,
                            },
                        },
                    },
                    ],
                },
                series: [{
                    name: "Statistics",
                    data: [20, 30, 40, 80, 50],
                },
                {
                    name: "Statistics",
                    data: [80, 70, 60, 20, 50],
                },
                ],
            },
        }
    }
}